import React from 'react';
import WrappedBase from './WrappedBase';

import createCalculatorStore from '../store';
import buildInitialState from '../initialState';
import CalculatorPageContainer from '../containers/CalculatorPageContainer';

export default class CalculatorPageWrapped extends React.Component {
  render() {
    const {
      membershipDiscountRate,
      pricePerPod,
      subscribableVariantFreeFrequency,
      locale,
      translatedMessages,
    } = this.props;

    const initialState = buildInitialState({
      membershipDiscountRate,
      pricePerPod,
      subscribableVariantFreeFrequency,
    });

    return (
      <WrappedBase
        store={createCalculatorStore({ initialState })}
        locale={locale}
        translatedMessages={translatedMessages}
      >
        <CalculatorPageContainer {...this.props} />
      </WrappedBase>
    );
  }
}
